import {escape} from 'html-escaper';

export default class TemplateHelper {
    /**
     * Escapes HTML characters and Vue template delimiters {{ and }}
     * to prevent Client-Side Template Injection (CSTI).
     */
    public static escape(str: any): string {
        if (typeof str !== 'string') {
            return str == null ? '' : String(str);
        }
        return escape(str)
            .replace(/{{/g, '&#123;&#123;')
            .replace(/}}/g, '&#125;&#125;');
    }
}
